import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"

import { computed } from "vue";
import { useTabBarStore } from "@/store";


export default /*@__PURE__*/_defineComponent({
  __name: 'page-layout',
  setup(__props) {

const tabBarStore = useTabBarStore();

const cacheList = computed(() => tabBarStore.getCacheList);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, null, {
    default: _withCtx(({ Component, route }) => [
      _createVNode(_Transition, {
        name: "fade",
        mode: "out-in",
        appear: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
            key: route.fullPath
          }))
        ]),
        _: 2
      }, 1024)
    ]),
    _: 1
  }))
}
}

})